import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/pemantauan-pacu`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/pemantauan-pacu", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/pemantauan-pacu/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/pemantauan-pacu/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function addMonitoring(id: number, data: any) {
  const response = await http
    .postData(`/pemantauan-pacu/${id}/monitoring`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateMonitoring(monitoringId: number, data: any) {
  const response = await http
    .putData(`/pemantauan-pacu-monitoring/${monitoringId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteMonitoring(monitoringId: number) {
  const response = await http
    .deleteData(`/pemantauan-pacu-monitoring/${monitoringId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signPerawat(id: number, data: { password: string }) {
  const response = await http
    .putData(`/pemantauan-pacu/${id}/sign-perawat`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signDokter(id: number, data: { password: string }) {
  const response = await http
    .putData(`/pemantauan-pacu/${id}/sign-dokter`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/pemantauan-pacu/${id}/pdf`, "_blank");
}

export default {
  getByRegister,
  create,
  update,
  destroy,
  addMonitoring,
  updateMonitoring,
  deleteMonitoring,
  signPerawat,
  signDokter,
  printPdf,
};
